// core
import React from "react";
import cx from "classnames";
import { QuoteTableView } from "../../../../enums/QuoteTableView";
import Toggle from "../../../../../common/components/Forms/Toggle/Toggle";
import styles from "./QuoteTableViewSwitcher.module.scss";

interface IQuoteTableViewSwitcherProps {
    className?: string;
    currentView: QuoteTableView;
    handleChangeQuoteTableView: (view: QuoteTableView) => void;
    isDisabled?: boolean;
    align?: "center" | "start";
}

// rendering
const QuoteTableViewSwitcher: React.FC<IQuoteTableViewSwitcherProps> = (props) => {
    const {
        currentView,
        handleChangeQuoteTableView,
        isDisabled,
        align,
        className
    } = props;

    const alignment = align || "center";

    return (
        <div
            className={cx(styles["layout-quote-table-view-switcher"], {
                [className]: !!className,
                [styles["layout-quote-table-view-switcher--centered"]]:
                    alignment === "center",
                [styles["layout-quote-table-view-switcher--start"]]: alignment === "start"
            })}>
            <Toggle
                name="ViewSwitcher"
                options={[
                    {
                        id: QuoteTableView.Overview,
                        label: "Overview",
                        selected: currentView === QuoteTableView.Overview
                    },
                    {
                        id: QuoteTableView.Details,
                        label: "All details",
                        selected: currentView === QuoteTableView.Details
                    }
                ]}
                onChange={(id) => handleChangeQuoteTableView(id as QuoteTableView)}
                isDisabled={isDisabled}
            />
        </div>
    );
};

export default React.memo(QuoteTableViewSwitcher);
